/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsModule_editorial = {
    readonly totalResults: number | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedInteriorsArticles_editorial">;
    readonly " $refType": "SbRespInteriorsModule_editorial";
};
export type SbRespInteriorsModule_editorial$data = SbRespInteriorsModule_editorial;
export type SbRespInteriorsModule_editorial$key = {
    readonly " $data"?: SbRespInteriorsModule_editorial$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespInteriorsModule_editorial">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespInteriorsModule_editorial",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalResults",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedInteriorsArticles_editorial"
    }
  ],
  "type": "WordpressArticlesType",
  "abstractKey": null
};
(node as any).hash = '138399f457f44aba9e6abd53abd5150d';
export default node;
